import { handlers, config } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;
const API = config.apiUrl.reportingAPI;

async function search(props) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/reportRecipients/search',
        body: JSON.stringify(props),
      }, API))
  );
}

async function getById(reportRecipientID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/reportRecipients/${reportRecipientID}`
      }, API))
  );
}

async function create(reportRecipient) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/reportRecipients',
        body: JSON.stringify({ reportRecipient })
      }, API))
  );
}

async function update(reportRecipient) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/reportRecipients/${reportRecipient.reportRecipientID}`,
        body: JSON.stringify({ reportRecipient })
      }, API))
  );
}

async function deleteRecipient(reportRecipientID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/reportRecipients/${reportRecipientID}`
      }, API))
  );
}

const reportRecipientService = {
  search,
  getById,
  create,
  update,
  delete: deleteRecipient
};

export default reportRecipientService;
